<template lang="pug">
AppLazySelect(
  v-model="selected"
  multiple
  label="Members"
  title="Select members"
  resource="member"
  :fetcher="fetcher"
)
  template(#item-leading="{ item }")
    AppAvatar(
      v-if="item.avatar"
      :avatar="item.avatar"
      size="speck"
    )
</template>

<script>
import { mapInertiaProps } from '~/utils/inertia';
import { AttendanceSchedulesResource } from '~/resources';

export default {
  name: 'AttendanceSchedulesMemberSelect',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  emits: ['input'],
  computed: {
    ...mapInertiaProps({
      organizationId: ({ organization }) => organization.id,
    }),
    selected: {
      get() {
        return this.form.userId;
      },
      set(userIds) {
        this.$emit('input', userIds);
      },
    },
  },
  methods: {
    fetcher(payload) {
      return AttendanceSchedulesResource.members({ organization_id: this.organizationId }, {...payload, managed_only: true}, {
        abortReload: true,
      });
    },
  },
};
</script>
